import classNames from "classnames";
import React from "react";

import { formatDate } from "@utils/date";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./storeStatus.scss";

const formatNextOpeningDate = (value: string | undefined) => {
    const date = new Date(value ?? "");

    if (isNaN(date.getTime())) return undefined;

    return formatDate(date, "dd/MM");
};

type StoreStatusComponentProps = {
    storeOpen: woosmap.map.stores.StoreOpen;
};

const StoreStatusComponent = ({ storeOpen }: StoreStatusComponentProps) => {
    const { t } = useGranite();

    const open = storeOpen.open_now;

    // @ts-ignore
    const nextOpeningDate = formatNextOpeningDate(storeOpen.next_opening?.day);
    // @ts-ignore
    const nextOpeingTime = storeOpen.next_opening?.start;
    const openClosesAt = open
        ? t(
              "form.searchstore.storeCard.status.closesAt",
              storeOpen.current_slice.end,
          )
        : nextOpeningDate && nextOpeingTime
        ? t(
              "form.searchstore.storeCard.status.opensAt",
              nextOpeningDate,
              nextOpeingTime,
          )
        : undefined;

    const statusText = t(
        `form.searchstore.storeCard.status.${open ? "open" : "closed"}`,
    );

    return (
        <p className={classNames("store-status", open && "store-status--open")}>
            <span>{statusText}</span>
            {openClosesAt && (
                <>
                    <span className={"store-status__separator"} />
                    <span>{openClosesAt}</span>
                </>
            )}
        </p>
    );
};

export { StoreStatusComponent };
